export default function usePercent(numerator: number, denominator: number) {
  return Math.floor((numerator / denominator) * 100) || 0
}
